define(
    'services/service.libraries',[
        "services/log",
        "providers/dataprovider"
    ],
    function(log, dataProvider) {
        var map = {};
        
        function getLookupValues(libraryId, name, isRefresh) {
            isRefresh = !isRefresh ? false : isRefresh;

            if (!libraryId)
                return $.when(true);

            var lookups = getLibraryLookups(libraryId);

            var d = $.Deferred();

            if (!lookups[name]) {
                lookups[name] = new Object();
                lookups[name]._state = "";
                lookups[name].d = [];

                isRefresh = true;
            }

            if (isRefresh) {
                if (lookups[name]._state == "loading") {

                    lookups[name].d.push(d);

                    return d.promise();
                }

                lookups[name]._state = "loading";
                lookups[name].d = [];

                dataProvider
                .lookups
                .getLookupValues(name, libraryId)
                .done(function (data) {
                    lookups[name].values = data;

                    d.resolve(data);

                    setTimeout(function () {

                        _.map(lookups[name].d, function (d) {
                            d.resolve(data);
                        });

                        lookups[name]._state = "";
                        lookups[name].d = [];

                    }, 1000);
                })
                .fail(function (e) {
                    lookups[name]._state = "";
                    lookups[name].d = [];

                    console.error(e);
                });
            } else {
                d.resolve(lookups[name].values);
            }

            return d.promise();
        }

        return {
            getLookupValues : getLookupValues
        };
        
        //#region Internal Methods

        function getLibraryLookups(libraryId) {
            if (!map[libraryId]) {
                map[libraryId] = {};
            }

            return map[libraryId];
        }

        //#endregion
    });
